import { useEffect, useState } from "react";
import { Users, Package, ShoppingCart, TrendingUp, UserCheck, DollarSign, RefreshCw, AlertTriangle, Clock, CreditCard } from "lucide-react";
import api from "@/lib/api";

function StatCard({ icon: Icon, label, value, color, bg }) {
  return (
    <div data-testid={`stat-${label.toLowerCase().replace(/\s/g, "-")}`} className="crm-card crm-stat">
      <div className="flex items-center justify-between">
        <span className="crm-stat-label">{label}</span>
        <div className="crm-stat-icon" style={{ background: bg, color }}>
          <Icon className="w-5 h-5" strokeWidth={1.5} />
        </div>
      </div>
      <p className="crm-stat-value">{value}</p>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/dashboard/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  if (!stats) return (
    <div className="space-y-8">
      <div className="h-8 rounded w-48" style={{ background: "var(--crm-border)" }} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {[...Array(9)].map((_, i) => <div key={i} className="h-32 crm-card animate-pulse" />)}
      </div>
    </div>
  );

  return (
    <div data-testid="crm-dashboard">
      <h1 className="crm-heading mb-8">Dashboard</h1>

      {/* Revenue section */}
      <div className="mb-8">
        <h2 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: "var(--crm-text-muted)" }}>Receita</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <StatCard icon={DollarSign} label="Receita Total" value={`¥${stats.revenue.toLocaleString()}`} color="#10b981" bg="rgba(16,185,129,0.1)" />
          <StatCard icon={RefreshCw} label="MRR (Mensal Recorrente)" value={`¥${stats.mrr.toLocaleString()}`} color="#06b6d4" bg="rgba(6,182,212,0.1)" />
          <StatCard icon={TrendingUp} label="Assinaturas Ativas" value={stats.active_subscriptions} color="#8b5cf6" bg="rgba(139,92,246,0.1)" />
        </div>
      </div>

      {/* Payments section */}
      <div className="mb-8">
        <h2 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: "var(--crm-text-muted)" }}>Pagamentos</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <StatCard icon={Clock} label="Pagamentos Pendentes" value={stats.pending_payments} color="#f97316" bg="rgba(249,115,22,0.1)" />
          <StatCard icon={AlertTriangle} label="Pagamentos Atrasados" value={stats.overdue_payments} color="#ef4444" bg="rgba(239,68,68,0.1)" />
          <StatCard icon={CreditCard} label="Valor Pendente" value={`¥${stats.pending_amount.toLocaleString()}`} color="#f59e0b" bg="rgba(245,158,11,0.1)" />
        </div>
      </div>

      {/* General section */}
      <div>
        <h2 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: "var(--crm-text-muted)" }}>Geral</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <StatCard icon={Users} label="Total Clientes" value={stats.total_customers} color="#3b82f6" bg="rgba(59,130,246,0.1)" />
          <StatCard icon={UserCheck} label="Clientes Ativos" value={stats.active_customers} color="#10b981" bg="rgba(16,185,129,0.1)" />
          <StatCard icon={ShoppingCart} label="Total Vendas" value={stats.total_sales} color="#f97316" bg="rgba(249,115,22,0.1)" />
        </div>
      </div>
    </div>
  );
}
